import { setCookie } from "nookies";
import React, { Suspense, useEffect, useState } from "react";
import InputMask from "react-input-mask";
import * as Styled from "./styled";

const WidgetComponent = React.lazy(() => import("../widget"));

const AccessForm = (props) => {
  const [chat, setChat] = useState(false);
  const [nome, setNome] = useState("");
  const [cpf, setCpf] = useState("");
  const [email, setEmail] = useState("");
  const [telefone, setTelefone] = useState("");

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");

    if (token) {
      setChat(true);
    }
  }, []);

  // const validateCPF = (cpf) => {
  //   const cleanCPF = cpf.replace(/\D/g, "");
  //   if (cleanCPF.length !== 11) return false;
  //   if (/^(\d)\1+$/.test(cleanCPF)) return false;
  //   return true;
  // };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validatePhone = (phone) => {
    const cleanPhone = phone.replace(/\D/g, "");
    return cleanPhone.length >= 10 && cleanPhone.length <= 11;
  };

  const handleStartChat = () => {
    // const cleanCPF = cpf.replace(/\D/g, "");

    if (!nome || !cpf || !email || !telefone) {
      console.error("Por favor, preencha todos os campos.");
      return;
    }

    // if (!validateCPF(cleanCPF)) {
    //   console.error("CPF inválido.");
    //   return;
    // }

    if (!validateEmail(email)) {
      console.error("E-mail inválido.");
      return;
    }

    if (!validatePhone(telefone)) {
      console.error("Telefone inválido.");
      return;
    }

    setCookie(null, "linkProtocol", JSON.stringify({ nome, cpf, email, phone: telefone.replace(/\D/g, "") }), {
      maxAge: 30 * 24 * 60 * 60,
      path: "/",
    });
    setChat(true);
  };

  if (chat) {
    return (
      <Suspense fallback={<></>}>
        <WidgetComponent form={chat} {...props} />
      </Suspense>
    );
  }

  return (
    <Styled.Container>
      <Styled.Form className="form_container">
        <p className="title">Identificação</p>
        <p>Preencha os dados abaixo para iniciar o atendimento.</p>
        <div>
          <Styled.FormControl>
            <Styled.TextField
              label="Nome"
              variant="outlined"
              fullWidth
              value={nome}
              onChange={(e) => setNome(e.target.value)}
            />
          </Styled.FormControl>
          <Styled.FormControl>
             <Styled.TextField
              label="CPF/CNPJ"
              variant="outlined"
              fullWidth
              value={cpf}
              onChange={(e) => setCpf(e.target.value)}
            />
          </Styled.FormControl>
          <Styled.FormControl>
            <Styled.TextField
              label="E-mail"
              variant="outlined"
              type="email"
              fullWidth
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Styled.FormControl>
          <Styled.FormControl>
            <InputMask
              mask="(99) 99999-9999"
              value={telefone}
              onChange={(e) => setTelefone(e.target.value)}
            >
              {(inputProps) => (
                <Styled.TextField
                  {...inputProps}
                  label="Telefone"
                  variant="outlined"
                  fullWidth
                />
              )}
            </InputMask>
          </Styled.FormControl>
          <Styled.ButtonContainer>
            <Styled.Button className="confirm" disabled={!nome || !cpf || !email || !telefone || !validateEmail(email) || !validatePhone(telefone)} type="button" onClick={handleStartChat}>
              Iniciar Chat
            </Styled.Button>
          </Styled.ButtonContainer>
        </div>
      </Styled.Form>
    </Styled.Container>
  );
};

export default AccessForm;
